export default __webpack_public_path__ + "static/media/sqrt.6ea2db75.svg";